__turbopack_context__.v({
  "active": "show-module-scss-module__QYcOWG__active",
  "contentContainer": "show-module-scss-module__QYcOWG__contentContainer",
  "contentDetails": "show-module-scss-module__QYcOWG__contentDetails",
  "contentNextAir": "show-module-scss-module__QYcOWG__contentNextAir",
  "lineupContent": "show-module-scss-module__QYcOWG__lineupContent",
  "lineupDetails": "show-module-scss-module__QYcOWG__lineupDetails",
  "lineupImg": "show-module-scss-module__QYcOWG__lineupImg",
  "lineupName": "show-module-scss-module__QYcOWG__lineupName",
  "longDescription": "show-module-scss-module__QYcOWG__longDescription",
  "moreDescription": "show-module-scss-module__QYcOWG__moreDescription",
  "nextAirBlock": "show-module-scss-module__QYcOWG__nextAirBlock",
  "nowPlaying": "show-module-scss-module__QYcOWG__nowPlaying",
  "nowPlayingHeadline": "show-module-scss-module__QYcOWG__nowPlayingHeadline",
  "roundCorners": "show-module-scss-module__QYcOWG__roundCorners",
  "scheduleDropdown": "show-module-scss-module__QYcOWG__scheduleDropdown",
  "scheduleDropdownDetail": "show-module-scss-module__QYcOWG__scheduleDropdownDetail",
  "shortDescription": "show-module-scss-module__QYcOWG__shortDescription",
  "showLineup": "show-module-scss-module__QYcOWG__showLineup",
  "showMoreText": "show-module-scss-module__QYcOWG__showMoreText",
  "showSchedule": "show-module-scss-module__QYcOWG__showSchedule",
  "showScheduleBtn": "show-module-scss-module__QYcOWG__showScheduleBtn",
});
